import { render, staticRenderFns } from "./NewsCard.vue?vue&type=template&id=ea3b0c7c&scoped=true&"
import script from "./NewsCard.vue?vue&type=script&lang=js&"
export * from "./NewsCard.vue?vue&type=script&lang=js&"
import style0 from "./NewsCard.vue?vue&type=style&index=0&id=ea3b0c7c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3b0c7c",
  null
  
)

export default component.exports